<ng-container *ngIf="showToast$ | async">
  <div class="travelToast__snackbar {{options?.toastClass}}">
    <app-ds-snackbar
      [type]="snackbarType"
      [message]="message"
      (clickEvent)="clickSnackbar()">
    </app-ds-snackbar>
  </div>
</ng-container>